import { DateTime } from 'luxon'
import isEmpty from 'lodash/isEmpty'

import { getData } from '@/services/storage.js'

export default {
  getterClientesCadastrados: (state) => state.clientesCadastrados && state.clientesCadastrados['NUM_CLIENTES_CADASTRADOS'],
  mesAnterior: (state) => state.lastUpdate && DateTime.fromFormat(state.lastUpdate.last_updated.toString(), 'yyyyMMdd').plus({ months: -1 }),
  anoAnterior: (state) => state.lastUpdate && DateTime.fromFormat(state.lastUpdate.last_updated.toString(), 'yyyyMMdd').plus({ years: -1 }),
  getLastUpdate: (state) => state.lastUpdate && DateTime.fromFormat(state.lastUpdate.last_updated.toString(), 'yyyyMMdd'),
  getQuickAction: (state) => (!isEmpty(state.quickAction) ? state.quickAction : getData('quickAction', {})),
  getPreFilters: (state) => (!isEmpty(state.preFilters) ? state.preFilters : getData('preFilters', {})),
  franchiseePermissionsRoutes: (state) => state.franchiseePermissionsRoutes,
  maintenanceReturnForecast: (state) => state.maintenanceReturnForecast,
  maintenanceModules: (state) => state.maintenanceModules,
  maintenanceAccountIds: (state) => state.maintenanceAccountIds,
  hasEnqueuedCashbackAdjustmentReport: (state) => state.hasEnqueuedCashbackAdjustmentReport,
  getSelectedIndustriesIds: (state) => state.filters.industries.map((industry) => industry._id),
}
